(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/common/assets/javascripts/retail-onboarding.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/common/assets/javascripts/retail-onboarding.js');

'use strict';

const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM,
  BREAKPOINT_LG = _svs$components$lbUti.BREAKPOINT_LG;
const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  Paper = _svs$ui.ReactPaper;
const RetailOnboarding = () => {
  let size = 800;
  const isAm = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const isLg = useMediaQuery(breakpoints.down(BREAKPOINT_LG));
  if (isLg) {
    size = 600;
  } else if (isAm) {
    size = 700;
  }
  return React.createElement("div", {
    className: "marketplace-welcome-wrap"
  }, React.createElement("ul", {
    className: "onboarding-cards"
  }, React.createElement("li", null, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement("div", {
    className: "paper-contain marketplace-onboarding-box"
  }, React.createElement("div", {
    className: "paper-rows"
  }, React.createElement(Icon, {
    color: "fc-sport-75",
    icon: "players",
    size: size
  }), React.createElement("div", {
    className: "text"
  }, React.createElement("h2", {
    className: "marketplace-onboarding-title"
  }, "Alla kan vara med")))))), React.createElement("li", null, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement("div", {
    className: "paper-contain marketplace-onboarding-box"
  }, React.createElement("div", {
    className: "paper-rows"
  }, React.createElement(Icon, {
    color: "fc-sport-75",
    icon: "my-habits",
    size: size
  }), React.createElement("div", {
    className: "text"
  }, React.createElement("h2", {
    "aria-label": "Tillsammans har ni st\xF6rre chans att vinna",
    className: "marketplace-onboarding-title"
  }, React.createElement("span", {
    "aria-hidden": "true"
  }, "Tillsammans har ni"), ' ', React.createElement("span", {
    "aria-hidden": "true"
  }, "st\xF6rre chans att vinna"))))))), React.createElement("li", null, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement("div", {
    className: "paper-contain marketplace-onboarding-box"
  }, React.createElement("div", {
    className: "paper-rows"
  }, React.createElement(Icon, {
    color: "fc-sport-75",
    icon: "simplicity",
    size: size
  }), React.createElement("div", {
    className: "text"
  }, React.createElement("h2", {
    "aria-label": "V\xE4lj butik och det spel som passar dig",
    className: "marketplace-onboarding-title"
  }, React.createElement("span", {
    "aria-hidden": "true"
  }, "V\xE4lj butik och det"), ' ', React.createElement("span", {
    "aria-hidden": "true"
  }, "spel som passar dig")))))))));
};
setGlobal('svs.marketplace.components.common.RetailOnboarding', RetailOnboarding);

 })(window);